import { render, staticRenderFns } from "./vFormMULTIPLE_CHOICE.vue?vue&type=template&id=3af56a9a&"
import script from "./vFormMULTIPLE_CHOICE.vue?vue&type=script&lang=js&"
export * from "./vFormMULTIPLE_CHOICE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports